import * as dateFns from 'date-fns';
import normalizeDate from 'src/utils/normalizeDate';

export default class AmortizationSchedule {
  constructor(
    originationDate,
    principal,
    annualInterestRate,
    loanTermInMonths,
    extraPayments = []
  ) {
    this.originationDate = normalizeDate(originationDate);
    this.principal = principal;
    this.annualInterestRate = annualInterestRate;
    this.loanTermInMonths = loanTermInMonths;
    this.extraPayments = extraPayments;
    this.monthlyInterestRate = annualInterestRate / 12 / 100;
    this.monthlyPayment = this.calculateMonthlyPayment();
    this.schedule = this.generateAmortizationSchedule();
  }

  calculateMonthlyPayment() {
    const r = this.monthlyInterestRate;
    const n = this.loanTermInMonths;
    return (this.principal * r) / (1 - (1 + r) ** -n);
  }

  generateAmortizationSchedule() {
    const schedule = [];
    let balance = this.principal;
    let totalInterestPaid = 0;

    for (let month = 1; month <= this.loanTermInMonths; month++) {
      const interestPayment = balance * this.monthlyInterestRate;
      const principalPayment = this.monthlyPayment - interestPayment;

      // Apply extra payments if any
      const extraPayment = this.extraPayments[month + 1] || 0;
      balance = Math.max(0, balance - principalPayment - extraPayment);
      totalInterestPaid += interestPayment;

      schedule.push({
        date: dateFns.addMonths(this.originationDate, month + 1),
        month,
        balance,
        principalPayment,
        interestPayment,
        extraPayment,
        totalInterestPaid,
      });
    }

    return schedule;
  }

  getAmortizationSchedule() {
    return this.schedule;
  }
}

// Example usage:

/*  

const principal = 100000; // Loan amount
const annualInterestRate = 5; // Annual interest rate in percent
const loanTermInMonths = 360; // Loan term in months (30 years)
const extraPayments = [100, 200, 300, 400, 500]; // Extra payments for each month (optional)

const amortization = new AmortizationSchedule(
  principal,
  annualInterestRate,
  loanTermInMonths,
  extraPayments
);
const schedule = amortization.getAmortizationSchedule();

// You can now access the amortization schedule and use it as needed
console.log(schedule);

*/
